import { createSlice, current } from '@reduxjs/toolkit';
import { QuoteGroupResponse } from '../../../shared/types/quotes';

interface QuoteState {
	quoteId: number | null;
	stage: number;
	stages: string[];
	quoteGroup: QuoteGroupResponse | undefined;
    creatingQuote: boolean;
}

const initialState: QuoteState = {
	quoteId: localStorage.getItem('quoteId') ? Number(localStorage.getItem('quoteId')) : null,
	stage: localStorage.getItem('stage') ? Number(localStorage.getItem('stage')) : 0,
	stages: ['Client details', 'Select products', 'Product questions', 'Bind cover'],
	quoteGroup: undefined,
    creatingQuote: false,
};

const quoteSlice = createSlice({
	name: 'quoteSlice',
	initialState,
	reducers: {
		setQuoteId: (state, action) => {
            // console.log('DISPATCH SET QUOTE ID', action.payload, 'LOCAL STORAGE QUOTE ID', localStorage.getItem('quoteId'));
            if (action.payload) {
                localStorage.setItem('quoteId', action.payload.toString());
            } else {
                localStorage.removeItem('quoteId');
            }
			state.quoteId = action.payload;
		},
		clearQuoteId: (state) => {
            // console.log('DISPATCH CLEAR QUOTE ID', state.quoteId, state.quoteGroup);
			state.quoteId = null;
			state.quoteGroup = undefined;
            state.creatingQuote = false;
			localStorage.removeItem('quoteId');
		},
		setStage: (state, action) => {
			state.stage = action.payload;
			localStorage.setItem('stage', action.payload.toString());
		},
		nextStage: (state) => {
			const newStage = Math.min(state.stage + 1, state.stages.length);
			// console.log('NEW STAGE', newStage);
			state.stage = newStage;
            if (newStage === 2) {
                state.creatingQuote = false;
            }
			localStorage.setItem('stage', newStage.toString());
		},
		prevStage: (state) => {
			const newStage = Math.max(state.stage - 1, 0);
			// console.log('NEW STAGE', newStage);
			state.stage = newStage;
			localStorage.setItem('stage', newStage.toString());
		},
		resetStage: (state) => {
			state.stage = 0;
            state.creatingQuote = false;
			localStorage.removeItem('stage');
		},
		setQuoteGroup: (state, action) => {
			console.log('[setQuoteGroup] action.payload', action.payload);
			state.quoteGroup = action.payload;
		},
        setCreatingQuote: (state, action) => {
            // console.log('[setCreatingQuote] action.payload', action.payload);
			state.creatingQuote = action.payload;
        }
	},
});

export const {
	setQuoteId,
	setQuoteGroup,
	clearQuoteId,
	setStage,
	nextStage,
	prevStage,
	resetStage,
    setCreatingQuote
} = quoteSlice.actions;
export default quoteSlice.reducer;
